// This file was automatically generated from render.chartFeedItemNew.plr.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.chartFeedItemNew.plr');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.docTags');
goog.require('el8.template.ptdata.model.note');
goog.require('el8.template.ptdata.model.order');
goog.require('el8.template.ptdata.model.order.referral');
goog.require('el8.template.ptdata.reports');
goog.require('el8.template.render.chartFeedItemNew');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.plr.reportItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemPLR am-highlight plr-result report-item">');
  el8.template.render.chartFeedItemNew.plr.plrNewDot(opt_data, output);
  output.append('<div class="el8FeedItemNewWrapper">');
  if (opt_data.sortByProviderActivity) {
    el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  } else {
    el8.template.render.chartFeedItemNew.dateColumn({feedDate: opt_data.report.documentDate}, output);
  }
  output.append('<div class="el8FeedItemColIcon">', (opt_data.report.reportType == 'lab') ? '<div class="el8ChartFeedIconLabReport"></div>' : (opt_data.report.formCollection) ? '<div class="el8ChartFeedIconFormCollection"></div>' : '<div class="el8ChartFeedIconReport"></div>', '<span class="el8PlrBadge"></span></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-plr-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine"><a class="el8FeedItemColMainTopLineLink plr-dialog-trigger" data-id="', soy.$$escapeHtml(opt_data.report.id), '">');
  el8.template.ptdata.reports.summary(soy.$$augmentData(opt_data.report, {doHighlight: true}), output);
  output.append('</a></div>');
  if (opt_data.report.abnormalResultNames.length) {
    output.append('<div class="el8FeedColMainLine">');
    el8.template.ptdata.reports.abnormalSummary(opt_data.report, output);
    output.append('</div>');
  }
  output.append('<!--', (opt_data.report.reportType == 'lab' && opt_data.report.collectedDate) ? '<div class="el8FeedColMainLine">Collected ' + (soy.$$escapeHtml(opt_data.report.collectedDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.report.collectedDate)) : '') + '</div>' : '', '-->', (opt_data.sortByProviderActivity) ? (opt_data.report.documentDate) ? '<div class="el8FeedColMainLine">Report Dated ' + (soy.$$escapeHtml(opt_data.report.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.report.documentDate)) : '') + '</div>' : '' : (opt_data.feedDate) ? '<div class="el8FeedColMainLine">Reviewed ' + (soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.feedDate)) : '') + '</div>' : '', '<!-- TODO: Figure out what to do with Doc Tags');
  el8.template.appshared.docTags.content({docTags: opt_data.report.docTags, feedItemId: opt_data.feedItemId}, output);
  output.append(' --><div class="el8FeedItemColSource"><span class="el8PLRSourceSpan">', soy.$$escapeHtml(opt_data.sharerName), '</span></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.plr.visitNoteItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemPLR plr-result visit-note-item">');
  el8.template.render.chartFeedItemNew.plr.plrNewDot(opt_data, output);
  output.append('<div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconReport"></div><span class="el8PlrBadge"></span></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-plr-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine"><a class="plr-dialog-trigger" data-id="', soy.$$escapeHtml(opt_data.item.id), '">', soy.$$escapeHtml(opt_data.item.type.name), ' ', (opt_data.item.signUserName) ? 'by ' + soy.$$escapeHtml(opt_data.item.signUserName) + ' ' : '', 'on ', (soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.feedDate)) : ''), '</a></div><div class="el8FeedColMainLine">CC/Reason: ', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.reason)) : soy.$$escapeHtml(opt_data.reason)), '</div><!-- TODO: Figure out what to do with Doc Tags');
  el8.template.appshared.docTags.content({docTags: opt_data.item.docTags, feedItemId: opt_data.feedItemId}, output);
  output.append(' --><div class="el8FeedItemColSource"><div class="el8FeedColSourceTopLine"><span class="el8PLRSourceSpan">', soy.$$escapeHtml(opt_data.sharerName), '</span></div></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.plr.nonvisitNoteItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemPLR plr-result nonvisit-note-item" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.render.chartFeedItemNew.plr.plrNewDot(opt_data, output);
  output.append('<div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconReport"></div><span class="el8PlrBadge"></span></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-plr-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine"><a class="plr-dialog-trigger" data-id="', soy.$$escapeHtml(opt_data.item.id), '">');
  el8.template.ptdata.model.note.nonvisitNoteDescription(soy.$$augmentData(opt_data, {typeName: opt_data.item.type.name}), output);
  output.append(' ', (opt_data.item.signUserName) ? 'by ' + soy.$$escapeHtml(opt_data.item.signUserName) + ' ' : '', 'on ', (soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.feedDate)) : ''), '</a></div><div class="el8FeedColMainLine el8SingleLineText">', soy.$$escapeHtml(opt_data.textPreview), '</div><!-- TODO: Figure out what to do with Doc Tags');
  el8.template.appshared.docTags.content({docTags: opt_data.item.docTags, feedItemId: opt_data.feedItemId}, output);
  output.append(' --><div class="el8FeedItemColSource"><div class="el8FeedColSourceTopLine"><span class="el8PLRSourceSpan">', soy.$$escapeHtml(opt_data.sharerName), '</span></div></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.plr.orderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemPLR plr-result order-item">');
  el8.template.render.chartFeedItemNew.plr.plrNewDot(opt_data, output);
  output.append('<div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconOrder"></div><span class="el8PlrBadge"></span></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-plr-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine">');
  if (opt_data.order.modelClass == 'ReferralOrder') {
    output.append('<a class="el8FeedItemColMainTopLineLink plr-dialog-trigger" data-id="', soy.$$escapeHtml(opt_data.order.id), '">');
    el8.template.ptdata.model.order.referral.feedSummary({order: opt_data.order, noExtraInfo: true}, output);
    output.append('</a>');
  } else {
    output.append('<a class="el8FeedItemColMainTopLineLink plr-dialog-trigger" data-id="', soy.$$escapeHtml(opt_data.order.id), '">Order: ');
    el8.template.ptdata.model.order.orderFeedSummary({order: opt_data.order, noExtraInfo: true}, output);
    output.append('</a>');
  }
  output.append('</div>', (opt_data.order.dateForTest) ? '<div class="el8FeedColMainLine">Do test on ' + (soy.$$escapeHtml(opt_data.order.dateForTest)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.dateForTest)) : '') + '</div>' : '', '<div class="el8FeedItemColSource"><span class="el8PLRSourceSpan">', soy.$$escapeHtml(opt_data.sharerName), '</span></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.plr.plrNewDot = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((el8.util.datecompare.cmp( new Date(opt_data.feedDate), new Date(opt_data.lastReviewTime) ) == 1) ? '<span class="el8FeedItemNewPlrMarker"></span>' : '');
  if (!opt_sb) return output.toString();
};
